(function () {
    'use strict';

    angular
        .module('ib-bob-form-module')
        .service('IbBobFormModel', IbBobFormModel);


    IbBobFormModel.$inject = ['localStorageService'];
    function IbBobFormModel (localStorageService) {
        const vm = this;
        vm.initializeModel = initializeModel;
        const flow = localStorageService.get('flowApp');
        function initializeModel (bobInfo) {
            return {
                pnr: flow !== 'MMB' ? localStorageService.get('bookingInfo').gdsLocator : localStorageService.get('bookingInfo').order.clientLocator,
                email: '',
                phone: '',
                services: fillSlices(bobInfo),
                priceTotal: 0,
                priceFrom: getPriceFrom(bobInfo),
                freeBagsIncluded: getFreeBagsIncluded(bobInfo),
                priceAdditionalBags: getPriceAdditionalBags(bobInfo),
                numBagsTotal: 0
            };
        }

        function fillSlices (bobInfo) {
            const bkiSegments = localStorageService.get('segmentsInfo');
            const segmentsData = localStorageService.get('segmentsSelected');
            const segments = [];
            let bkiSegmentsSelected, arrivalSegmentsSelected;
            angular.forEach(bobInfo.slices, (slice) => {
                const sliceId = slice.sliceId;
                const ids = sliceId.split('_');
                const selectedSegmentsFounded = segmentsData.filter((segmentElement) => {
                    return String(ids[0]) === String(segmentElement.id);
                });
                const arrivalSegmentsFounded = segmentsData.filter((segmentElement) => {
                    return String(ids[ids.length - 1]) === String(segmentElement.id);
                });
                if (flow !== 'MMB') {
                    bkiSegmentsSelected = bkiSegments.filter((segmentElement) => {
                        return String(ids[0]) === String(segmentElement.id);
                    });
                    arrivalSegmentsSelected = bkiSegments.filter((segmentElement) => {
                        return String(ids[ids.length - 1]) === String(segmentElement.id);
                    });
                } else {
                    const bookingInfo = localStorageService.get('bookingInfo').order?.slices?.find((slice) => slice.sliceId === ids[0]);
                    const segmentId = bookingInfo.segments[0].id;
                    bkiSegmentsSelected = bkiSegments.filter((segmentElement) => {
                        return segmentId === String(segmentElement.id);
                    });
                    arrivalSegmentsSelected = bkiSegments.filter((segmentElement) => {
                        return segmentId === String(segmentElement.id);
                    });
                }
                if (selectedSegmentsFounded.length > 0) {
                    const segment = {
                        sliceId: sliceId,
                        departure: {},
                        arrival: {},
                        passengers: fillPassengers(),
                        pickUpSlot: {},
                        baggage: 0,
                        priceTotal: 0,
                        priceFrom: slice.products[0].price,
                        freeBagsIncluded: slice.products[0].freeBagsIncluded,
                        priceAdditionalBags: slice.products[0].additionalBagsPrice
                    };
                    segment.departure = completeDataLocation(selectedSegmentsFounded[0], bkiSegmentsSelected[0], 'origin', 'departure');
                    segment.arrival = completeDataLocation(arrivalSegmentsFounded[0], arrivalSegmentsSelected[0], 'destination', 'arrival');
                    segments.push(segment);
                }
            });

            return segments;
        }

        function completeDataLocation (selectedSegmentsFounded, segment, location, key) {
            const data = selectedSegmentsFounded[key];
            data.code = segment[location].code;
            data.description = segment[location].description;
            return data;
        }

        function fillPassengers () {
            const bookingPassengers = localStorageService.get('bookingInfo').passengers;
            const passengers = [];

            for (let index = 0; bookingPassengers.length > index; index++) {
                const bkiPassenger = bookingPassengers[index];
                const passenger = {
                    name: flow !== 'MMB' ? bkiPassenger.name : bkiPassenger.personalInfo.name,
                    surname: flow !== 'MMB' ? bkiPassenger.surname : bkiPassenger.personalInfo.surname,
                    ticketNumber: flow !== 'MMB' ? getTicketNumber(bkiPassenger.id) : getTicketNumber(bkiPassenger.passengerId),
                    numBags: 0,
                    priceTotalBags: 0
                };
                passengers.push(passenger);
            }
            return passengers;
        }

        function getPriceFrom (bobInfo) {
            return bobInfo.slices[0].products[0].price;
        }
        function getFreeBagsIncluded (bobInfo) {
            return bobInfo.slices[0].products[0].freeBagsIncluded;
        }
        function getPriceAdditionalBags (bobInfo) {
            return bobInfo.slices[0].products[0].additionalBagsPrice;
        }

        function getTicketNumber (passengerId) {
            if (flow !== 'MMB') {
                const bookingSegments = localStorageService.get('bookingInfo').outwardSegments;
                let indexSegment, indexPassenger;
                for (indexSegment = 0; bookingSegments.length >= indexSegment; indexSegment++) {
                    const bkiSegPassengers = bookingSegments[indexSegment] ? bookingSegments[indexSegment].passengers : [];
                    for (indexPassenger = 0; bkiSegPassengers.length > indexPassenger; indexPassenger++) {
                        const passenger = bkiSegPassengers[indexPassenger];
                        if (passenger.ticket && passenger.id === passengerId) {
                            return passenger.ticket.number;
                        }
                    }
                }
            } else {
                const tickets = localStorageService.get('bookingInfo').tickets;
                const ticket = tickets.find(ticket => ticket.passengerId === passengerId);
                return ticket.ticketNumbers[0];
            }
        }
    }
})();

